export default {
    ordered: {
        error: {
            dependency_0001: "Nem rendelhető, mert {name} a kosárban van | Nem rendelhető, mert {name} a kosárban van",
            dependency_0002: "Nem rendelhető, mert {name} megrendelve | Nem rendelhető, mert {name} megrendelve",
            cart: "Nem rendelhető, mert azonos típusú tételek vannak a kosárban"
        },
        type: {
            "ac_router": "Már rendeltem egy másik AC Routert",
            "chair": "Már rendeltem egy másik széket",
            "default": "Már megrendeltem",
            "default_multiple": "Már rendeltem hasonló termékeket",
            "desk": "Már rendeltem egy másik íróasztalt",
            "desktop": "Már rendeltem egy másik asztali gépet",
            "desktop_riser": "Már rendeltem egy másik asztali emelőt",
            "detector": "Már rendeltem egy másik vape-et és zajérzékelőt",
            "displayport_cable": "Már rendeltem egy másik DisplayPort kábelt",
            "docking station": "Már rendeltem egy másik dokkolóállomást",
            "dual_usb_adapter": "Már rendeltem egy másik kétsávos USB adaptert",
            "ear cushion": "Már rendeltem egy másik fülpárnát",
            "footrest": "Már rendeltem egy másik lábtartót",
            "hdmi_cable": "Már rendeltem különböző HDMI kábeleket",
            "hdmi_displayport_cable": "Már rendeltem egy másik HDMI-DisplayPort kábelt",
            "hdmi_vga_cable": "Már rendeltem egy másik HDMI-VGA kábelt",
            "headset": "Már rendeltem egy másik audioeszközt",
            "keyboard": "Már rendeltem egy másik billentyűzetet",
            "kvm switch": "Már rendeltem egy másik KVM switchet",
            "kvm_switch": "Már rendeltem egy másik KVM switchet",
            "lamp": "Már rendeltem egy másik lámpát",
            "laptop stand": "Már rendeltem egy másik laptop állványt",
            "laptop": "Már rendeltem egy másik laptopot",
            "mesh_router": "Már rendeltem egy másik mesh routert",
            "monitor": "Már rendeltem egy másik monitort",
            "mouse": "Már rendeltem különböző egereket",
            "patch_cord": "Már rendeltem egy másik cat6 patch kábelt",
            "power": "Már rendeltem egy másik tápkábelt",
            "power_center": "Már rendeltem egy másik Power Centert",
            "power_strip": "Már rendeltem egy másik elosztót",
            "printer": "Már rendeltem egy másik nyomtatót",
            "smart_plug": "Már rendeltem egy másik okos mini csatlakozót",
            "smart_power_strip": "Már rendeltem egy másik okos elosztót",
            "speakerphone": "Már rendeltem egy másik kihangosítót",
            "stylus": "Már rendeltem egy másik stylust",
            "tablet": "Már rendeltem egy másik tabletet",
            "tablet accessory": "Már rendeltem egy másik tablet kiegészítőt",
            "thunderbolt_cable": "Már rendeltem egy másik USB-C - Thunderbolt kábelt",
            "travel_router": "Már rendeltem egy másik utazó routert",
            "usb hub": "Már rendeltem egy másik USB elosztót",
            "usb_adapter": "Már rendeltem egy másik USB adaptert",
            "usb_hub": "Már rendeltem egy másik hubot",
            "webcam": "Már rendeltem egy másik webkamerát"
        },
        product: "Rendelt"
    },
    request: "Kér",
    add: "Kosárba",
    remove: "Eltávolítás a kosárból",
    added: "Kosárba helyezve",
    view: "Elem megtekintése"
}